import { useCallback, useEffect, useState } from "react";

/**
 * v2 equivalent of the legacy `useVisibilityState` hook — tracks whether the
 * tab is in the foreground. Used to gate polling (driver location, ETA
 * eligibility) so a backgrounded tab doesn't keep hammering the network,
 * mirroring the `userActive` checks throughout the legacy Map/ETA code.
 */
export function useDocumentVisibility(): boolean {
  const [isVisible, setIsVisible] = useState(() => document.visibilityState === "visible");

  const handleChange = useCallback(() => {
    setIsVisible(document.visibilityState === "visible");
  }, []);

  useEffect(() => {
    document.addEventListener("visibilitychange", handleChange, { passive: true });
    return () => document.removeEventListener("visibilitychange", handleChange);
  }, [handleChange]);

  return isVisible;
}
